import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const RubricsIconSvgGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M7.63672 14.875H1.69922C1.53346 14.875 1.37449 14.8092 1.25728 14.6919C1.14007 14.5747 1.07422 14.4158 1.07422 14.25V1.75C1.07422 1.58424 1.14007 1.42527 1.25728 1.30806C1.37449 1.19085 1.53346 1.125 1.69922 1.125H11.0742C11.24 1.125 11.3989 1.19085 11.5162 1.30806C11.6334 1.42527 11.6992 1.58424 11.6992 1.75V6.75"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1708 8.80073L12.972 10.9164H14.5345C14.6132 10.9132 14.691 10.9345 14.7572 10.9772C14.8234 11.0199 14.8748 11.0821 14.9043 11.1551C14.9339 11.2282 14.9402 11.3086 14.9223 11.3853C14.9044 11.462 14.8633 11.5314 14.8045 11.5839L13.4508 12.5276L14.1976 14.2501C14.2304 14.329 14.2376 14.4162 14.2182 14.4994C14.1988 14.5826 14.1539 14.6576 14.0897 14.7139C14.0255 14.7703 13.9453 14.8051 13.8602 14.8135C13.7752 14.8219 13.6897 14.8034 13.6158 14.7607L11.8033 13.7414L9.99077 14.7607C9.91678 14.8037 9.83119 14.8223 9.74605 14.814C9.66091 14.8057 9.58051 14.7709 9.51619 14.7146C9.45186 14.6582 9.40685 14.583 9.38749 14.4997C9.36813 14.4164 9.3754 14.3291 9.40827 14.2501L10.1583 12.5276L8.80452 11.5839C8.74553 11.5316 8.70414 11.4624 8.68602 11.3858C8.6679 11.3091 8.67394 11.2287 8.7033 11.1556C8.73267 11.0825 8.78392 11.0203 8.85005 10.9774C8.91617 10.9346 8.99392 10.9133 9.07264 10.9164H10.6351L11.4376 8.80073C11.4728 8.73399 11.5256 8.67813 11.5902 8.63916C11.6548 8.60019 11.7288 8.57959 11.8042 8.57959C11.8796 8.57959 11.9537 8.60019 12.0183 8.63916C12.0829 8.67813 12.1356 8.73399 12.1708 8.80073Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.34375 5.59304C5.34375 5.86953 5.45358 6.13469 5.64909 6.3302C5.8446 6.5257 6.10976 6.63554 6.38625 6.63554C6.66274 6.63554 6.9279 6.5257 7.12341 6.3302C7.31892 6.13469 7.42875 5.86953 7.42875 5.59304C7.42875 5.31655 7.31892 5.05139 7.12341 4.85588C6.9279 4.66037 6.66274 4.55054 6.38625 4.55054C6.10976 4.55054 5.8446 4.66037 5.64909 4.85588C5.45358 5.05139 5.34375 5.31655 5.34375 5.59304Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.26125 8.90739C8.15485 8.49148 7.91303 8.12282 7.57393 7.85954C7.23483 7.59627 6.81774 7.45337 6.38844 7.45337C5.95913 7.45337 5.54204 7.59627 5.20294 7.85954C4.86384 8.12282 4.62202 8.49148 4.51562 8.90739"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.10938 6.2156C3.10937 6.64592 3.19413 7.07203 3.35881 7.4696C3.52349 7.86717 3.76486 8.22841 4.06915 8.5327C4.37344 8.83698 4.73468 9.07836 5.13224 9.24303C5.52981 9.40771 5.95592 9.49247 6.38625 9.49247C6.81658 9.49247 7.24269 9.40771 7.64026 9.24303C8.03782 9.07836 8.39906 8.83698 8.70335 8.5327C9.00764 8.22841 9.24901 7.86717 9.41369 7.4696C9.57837 7.07203 9.66313 6.64592 9.66313 6.2156C9.66313 5.34651 9.31788 4.51303 8.70335 3.8985C8.08882 3.28396 7.25533 2.93872 6.38625 2.93872C5.51717 2.93872 4.68368 3.28396 4.06915 3.8985C3.45462 4.51303 3.10938 5.34651 3.10938 6.2156Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.09375 12.3875H6.53125"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const RubricsIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <RubricsIconSvgGroup {...props} />
    </svg>
  );
};
